import FilteredContactList from './FilteredContactList';

const entity = new FilteredContactList('billingAccountContacts');

export {entity};
